import styled from '@emotion/styled'
import { Shapes } from 'src/components/theme'

const Box = styled.div<{ color: string; secondaryColor: string }>`
  color: ${(props) => props.color};
  border: 1px solid ${(props) => props.color};
  background-color: ${(props) => props.secondaryColor};
  border-radius: ${Shapes.borderRadius}px;
  display: flex;
  justify-content: center;
  align-items: center;
`
type IconBoxProps = {
  size?: number
  color: string
  secondaryColor: string
  children: React.ReactNode
}
export const IconBox = (props: IconBoxProps) => {
  const { size, children, color, secondaryColor } = props
  return (
    <Box color={color} secondaryColor={secondaryColor} style={{ width: size, height: size }}>
      {children}
    </Box>
  )
}
